import { httpsCallable } from 'firebase/functions';
import { functionsEu } from '../firebase';

// Stuurt onverwachte fouten uit de browser naar de Cloud Function reportClientError, die ze in
// Cloud Logging / Error Reporting zet. Zonder dit merkt niemand een wit scherm of een kapotte
// knop bij een klant. Bewust zuinig: hooguit enkele meldingen per paginabezoek, elke fout één
// keer, en zonder gebruikersgegevens (enkel de foutmelding, de stack en het pad).
const MAX_REPORTS_PER_VISIT = 5;
const reported = new Set();
let sent = 0;

// Fouten die geen fout van onze code zijn: een netwerk dat even wegvalt, een
// browserextensie, of een melding die de browser zelf als onschuldig bestempelt.
const IGNORED = [
    /ResizeObserver loop/i,
    /Failed to fetch/i,
    /NetworkError/i,
    /Load failed/i,
    /network-request-failed/i,
    /chrome-extension:\/\//i,
    /moz-extension:\/\//i,
    /Script error\.?$/i
];

export function reportError(error, source) {
    try {
        if (sent >= MAX_REPORTS_PER_VISIT) return;
        const message = String((error && error.message) || error || 'Onbekende fout').slice(0, 500);
        const stack = String((error && error.stack) || '').slice(0, 3000);
        if (IGNORED.some((pattern) => pattern.test(message) || pattern.test(stack))) return;

        const key = `${source}|${message}`;
        if (reported.has(key)) return;
        reported.add(key);
        sent += 1;

        httpsCallable(functionsEu, 'reportClientError')({
            message,
            stack,
            source,
            path: window.location.pathname
        }).catch(() => { /* een mislukte melding mag nooit een nieuwe fout veroorzaken */ });
    } catch {
        // Foutrapportage mag de app nooit breken.
    }
}

export function installGlobalErrorReporting() {
    window.addEventListener('error', (event) => reportError(event.error || event.message, 'window'));
    window.addEventListener('unhandledrejection', (event) => reportError(event.reason, 'promise'));
}
